import { useCallback, useEffect, useRef, useState } from "react";
import { getApiErrorMessage } from "../http/apiError";

export const useAsyncData = (loader, options = {}) => {
    const {
        immediate = true,
        deps = [],
        initialData = null,
        mapData = (data) => data,
        onSuccess,
        onError,
        errorMessage = "Ошибка загрузки данных",
    } = options;

    const [data, setData] = useState(initialData);
    const [loading, setLoading] = useState(Boolean(immediate));
    const [error, setError] = useState(null);
    const mountedRef = useRef(true);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const reload = useCallback(async (...args) => {
        setLoading(true);
        setError(null);

        try {
            const result = await loader(...args);
            const mapped = mapData(result);

            if (!mountedRef.current) return mapped;

            setData(mapped);
            if (onSuccess) onSuccess(mapped, result);
            return mapped;
        } catch (e) {
            if (!mountedRef.current) throw e;

            setError(e);
            if (onError) {
                onError(e);
            } else {
                console.error(getApiErrorMessage(e, errorMessage));
            }
            throw e;
        } finally {
            if (mountedRef.current) setLoading(false);
        }
    }, deps);

    useEffect(() => {
        if (!immediate) return undefined;
        reload().catch(() => {});
        return undefined;
    }, [reload, immediate]);

    return { data, setData, loading, error, reload };
};
